/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProposalSummaryClientDetails } from './ProposalSummaryClientDetails';
import {
    ProposalSummaryClientDetailsFromJSON,
    ProposalSummaryClientDetailsFromJSONTyped,
    ProposalSummaryClientDetailsToJSON,
} from './ProposalSummaryClientDetails';
import type { ProposalSummaryDetails } from './ProposalSummaryDetails';
import {
    ProposalSummaryDetailsFromJSON,
    ProposalSummaryDetailsFromJSONTyped,
    ProposalSummaryDetailsToJSON,
} from './ProposalSummaryDetails';
import type { ProposalSummaryInvestmentDetails } from './ProposalSummaryInvestmentDetails';
import {
    ProposalSummaryInvestmentDetailsFromJSON,
    ProposalSummaryInvestmentDetailsFromJSONTyped,
    ProposalSummaryInvestmentDetailsToJSON,
} from './ProposalSummaryInvestmentDetails';
import type { QuoteReportRules } from './QuoteReportRules';
import {
    QuoteReportRulesFromJSON,
    QuoteReportRulesFromJSONTyped,
    QuoteReportRulesToJSON,
} from './QuoteReportRules';

/**
 * 
 * @export
 * @interface ProposalSummaryViewModel
 */
export interface ProposalSummaryViewModel {
    /**
     * 
     * @type {ProposalSummaryDetails}
     * @memberof ProposalSummaryViewModel
     */
    proposalDetails: ProposalSummaryDetails;
    /**
     * 
     * @type {ProposalSummaryClientDetails}
     * @memberof ProposalSummaryViewModel
     */
    clientDetails: ProposalSummaryClientDetails;
    /**
     * 
     * @type {ProposalSummaryInvestmentDetails}
     * @memberof ProposalSummaryViewModel
     */
    investmentDetails: ProposalSummaryInvestmentDetails;
    /**
     * 
     * @type {QuoteReportRules}
     * @memberof ProposalSummaryViewModel
     */
    quoteReportRules: QuoteReportRules;
}

/**
 * Check if a given object implements the ProposalSummaryViewModel interface.
 */
export function instanceOfProposalSummaryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "proposalDetails" in value;
    isInstance = isInstance && "clientDetails" in value;
    isInstance = isInstance && "investmentDetails" in value;
    isInstance = isInstance && "quoteReportRules" in value;

    return isInstance;
}

export function ProposalSummaryViewModelFromJSON(json: any): ProposalSummaryViewModel {
    return ProposalSummaryViewModelFromJSONTyped(json, false);
}

export function ProposalSummaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proposalDetails': ProposalSummaryDetailsFromJSON(json['ProposalDetails']),
        'clientDetails': ProposalSummaryClientDetailsFromJSON(json['ClientDetails']),
        'investmentDetails': ProposalSummaryInvestmentDetailsFromJSON(json['InvestmentDetails']),
        'quoteReportRules': QuoteReportRulesFromJSON(json['QuoteReportRules']),
    };
}

export function ProposalSummaryViewModelToJSON(value?: ProposalSummaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProposalDetails': ProposalSummaryDetailsToJSON(value.proposalDetails),
        'ClientDetails': ProposalSummaryClientDetailsToJSON(value.clientDetails),
        'InvestmentDetails': ProposalSummaryInvestmentDetailsToJSON(value.investmentDetails),
        'QuoteReportRules': QuoteReportRulesToJSON(value.quoteReportRules),
    };
}

